module.exports = __webpack_public_path__ + "img/lc-edit.71b588fe.svg";